<div class="row" [class.background]="showCorrect" [class.correct]="result.correct" [class.wrong]="!result.correct && !result.skipped">
  <div class="nowrap mat-title-medium">{{result.team | teamName}}:</div>
  <div>{{details}}</div>
</div>
